import {path, view} from '@acng/frontend-voyager';

import {userRoute} from 'acng/userPool/config/routes';

import {pinFeature} from './feature.js';

if (!pinFeature.isHidden) {
  userRoute.create(
    path('/pins'),
    view('main', () => pinFeature.lookup('pins'))
  );
}
